import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerComponent } from './customer/customer.component';
import { PanelComponent } from './panel/panel.component';
import { ProductComponent } from './product/product.component';
import { ReportComponent } from './report/report.component';

const routes: Routes = [
  {
    path:'',
    redirectTo:'customer',
    pathMatch:'full'
  },
  {
    path:'customer',
    component:CustomerComponent
  },
  {
    path:'product',
    component:ProductComponent
  },
  {
    path:'panel',
    component:PanelComponent
  },
  {
    path:'report',
    component:ReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
